import { BatchSuggestion } from "@src/core/engine/workers/batchSelection/schema";
import { BuildSuggestionOutput } from "@src/routes/projects/$projectId/selections/hooks/useBuildSuggestionOutput";
import { GetGroupedProductDescriptions } from "@src/shared/components/ProductDetailsCard/hooks/useGetProductDescriptions";
import { group, listify, objectify } from "radashi";
import { BatchFormattedSuggestion } from "../types";

export function buildBatchFormattedSuggestion(
  suggestion: BatchSuggestion,
  buildSuggestionOutput: BuildSuggestionOutput,
  getProductDescriptions: GetGroupedProductDescriptions,
): BatchFormattedSuggestion {
  return {
    ...suggestion,
    description: objectify(
      getProductDescriptions(suggestion),
      (value) => value.id,
      (value) => value.description,
    ),
    output: objectify(
      listify(
        group(suggestion.output, (item) => item.translationKey),
        buildSuggestionOutput,
      ),
      (value) => value.id,
      (value) => value,
    ),
  };
}
